export const wasteMap = new Map([
    ['porterbottles', '寶特瓶'],
    ['cans', '鐵罐'],
    ['aluminumcans', '鋁罐'],
    ['glassbottles', '玻璃瓶'],
    ['wastepaper', '廢紙'],
    ['styrofoam', '保麗龍'],
    ['fishinggear', '漁網漁具'],
])
